import React, { useEffect, useState } from "react";
import styled from "styled-components";

const FloatLayout = ({
  onOverlayClick,
  visible,
  content,
  className,
  onDisappear
}) => {
  const [show, setShow] = useState(false);

  const handleBodyClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
  }

  const handleMaskClick = () => {
    onOverlayClick && onOverlayClick();
  }

  useEffect(() => {

    
    if (visible) {
      setTimeout(() => {
     
        setShow(true);
        document.body.style.overflow = 'hidden'
      }, 200)
    } else {
      setTimeout(() => {
        setShow(false);
        document.body.style.overflow = 'unset'
        onDisappear && onDisappear();
      }, 200)
    }
  }, [visible])


  return (
    <Container className={`${className || '' } ${show ? 'float-layout_active' : ''}`}>
      <div onClick={handleMaskClick} className={`float-layout_overlay ${visible ? 'float-layout_overlay_active' : ''}`}></div>
      <div
        className={`float-layout_body ${visible ? 'float-layout_body_active' : ''}`}
      >
        <div onClick={handleBodyClick} className="float-layout_box">
          {content}
        </div>
      </div>
    </Container>
  )
}

export default React.memo(FloatLayout);

const Container = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  visibility: hidden;
  z-index: 999;
  &.float-layout_active {
    visibility: visible;
  }
  .float-layout_overlay {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    background-color: rgba(0, 0, 0, 0.6);
    opacity: 0;
    transition: opacity 150ms ease-in;
  }
  .float-layout_overlay_active {
    opacity: 1;
  }
  .float-layout_body {
    position: absolute;
    bottom: 0;
    width: 100%;
    transform: translate3d(0, 100%, 0);
    transition: transform 300ms;
  }
  .float-layout_body_active {
    transform: translate3d(0, 0, 0);
  }
`;



// WEBPACK FOOTER //
// ./src/components/float-layout/index.js